import React from 'react';
import {Link} from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const Footer = () => {
    return (
        <>
            <footer>
                <div className="footer max-w-full mx-auto px-4 sm:px-6 bg-gray-100 border-t border-b py-30">

                    {/* Top area: Blocks */}
                    <div className="grid sm:grid-cols-12 gap-5 py-8 md:py-12 border-t border-gray-200">
                        {/* LINKS block */}
                        <div className="col-span-12 md:col-span-4 text-center mx-auto">
                            <h6 className="text-[#013289] text-xl font-bold mb-4">LINKS</h6>
                            <ul className="text-md">
                                <li className="mb-2">
                                    <HashLink to="/#about" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">About</HashLink>
                                </li>
                                <li className="mb-2">
                                    <HashLink to="/#services" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Services</HashLink>
                                </li>
                                <li className="mb-2">
                                    <HashLink to="/contact" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Contact</HashLink>
                                </li>                            
                            </ul>
                        </div>

                        {/* OUR SERVICES block */}
                        <div className="col-span-12 md:col-span-4 text-center mx-auto">
                            <h6 className="text-[#013289] text-xl font-bold mb-4">OUR SERVICES</h6>
                            <ul className="text-md">
                                <li className="mb-2">
                                    <HashLink to="/#services" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Fortnite Creative Custom Island</HashLink>
                                </li>
                                <li className="mb-2">
                                    <HashLink to="/#services" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Web3 Telegram Apps Development</HashLink>
                                </li>
                                <li className="mb-2">
                                    <HashLink to="/#services" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Domain and Hosting Services</HashLink>
                                </li>
                                <li className="mb-2">
                                    <HashLink to="/#services" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">VR/AR Game Design</HashLink>
                                </li>
                            </ul>
                        </div>

                        {/* SOCIAL MEDIA block */}
                        <div className="col-span-12 md:col-span-4 text-center mx-auto">
                            <div className="text-xl mb-6 text-blue-900 font-bold">
                                Social Media Links.
                            </div>
                            <div className="text-md font-medium mb-6">
                                Follow us on social media.
                            </div>
                            <div className="mx-auto text-center mt-2">
                                <ul className="flex justify-center mb-4 md:mb-0">
                                    <li>
                                        <a href="https://x.com/superappgames" target="_blank" rel="noopener noreferrer" className="flex justify-center items-center text-blue-900 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out" aria-label="X">
                                            <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16.75,5l-3.15,3.15L7.4,5H5L12.4,12.4L4,22h2.35l2.4-2.85L12,22h2.4l-4.25-5.1L16.75,5z M6.95,6.35H8.6l10.15,11.95h-1.55 L6.95,6.35z" />
                                            </svg>
                                        </a>
                                    </li>
                                    <li className="ml-4">
                                        <a href="https://www.linkedin.com/company/superapp-games/" target="_blank" rel="noopener noreferrer" className="flex justify-center items-center text-blue-900 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out" aria-label="LinkedIn">
                                            <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9,25H5V10h4V25z M7,8.24C5.8,8.24,4.8,7.24,4.8,6C4.8,4.76,5.8,3.76,7,3.76c1.2,0,2.2,1,2.2,2.24 C9.2,7.24,8.2,8.24,7,8.24z M27,25h-4v-7.47c0-1.66-0.03-3.8-2.2-3.8c-2.2,0-2.53,1.81-2.53,3.67V25h-4V10h3.84v1.86h0.05 c0.56-1.06,1.92-2.19,3.95-2.19c4.23,0,5.01,2.78,5.01,6.41V25H27z" />
                                            </svg>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Copyright section */}
                    <div className="flex flex-wrap items-center justify-center mx-auto px-4">
                        <div className="w-full md:w-4/12 px-4 mx-auto text-center py-2">
                            <div className="text-sm text-gray-200 font-semibold py-1">
                                Copyright &copy; {new Date().getFullYear()}{"  "}
                                <HashLink to="/#hero" className="hover:text-gray-900">
                                    SuperApp Games
                                </HashLink>. All rights reserved.
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}
export default Footer;
